import { z } from "zod";

export const timestampSchema = z.object({
  type: z.string(),
  desc: z.nullable(z.string()),
  lat: z.nullable(z.number()),
  lng: z.nullable(z.number()),
  time: z.nullable(z.number()),
  accuracy: z.nullable(z.number()),
});
